import { atom } from "jotai";
import { Refresh } from "../types/refresh";

export const refreshAtomNotification = atom<Refresh | null>(null);
